<template>
  <div>
    GOING
    <input
      type="text"
      v-model="inputMessageGoing"
      @keydown.enter="addMessage('GOING')"
    />
    COMING
    <input
      type="text"
      v-model="inputMessageComing"
      @keydown.enter="addMessage('COMING')"
    />
    <div style="height: 20vh">
      <ContainerChatAutoScroll>
        <div
          v-for="(itemMessage, indexMessage) in listMessage"
          :key="indexMessage"
        >
          <p>{{ itemMessage.message }}</p>
        </div>
      </ContainerChatAutoScroll>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import ContainerChatAutoScroll from '@/components/shared/composite/ContainerChatAutoScroll.vue';

interface ItemMessage {
  message: string;
  type: 'COMING' | 'GOING';
}

const inputMessageGoing = ref('');
const inputMessageComing = ref('');
const listMessage = ref([] as ItemMessage[]);

const addMessage = (type: 'COMING' | 'GOING') => {
  if (type === 'GOING') {
    listMessage.value.push({ message: inputMessageGoing.value, type });
    inputMessageGoing.value = '';
  }
  if (type === 'COMING') {
    listMessage.value.push({ message: inputMessageComing.value, type });
    inputMessageComing.value = '';
  }
};
</script>

<style scoped></style>
